import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useTranslation } from 'next-i18next';
interface DataProjectDialogProps {
  children: React.ReactNode;
}
const DataProjectDialog: React.FC<DataProjectDialogProps> = ({
  children
}) => {
  const {
    t
  } = useTranslation('footer');
  return <Dialog data-sentry-element="Dialog" data-sentry-component="DataProjectDialog" data-sentry-source-file="data-project-dialog.tsx">
      <DialogTrigger asChild data-sentry-element="DialogTrigger" data-sentry-source-file="data-project-dialog.tsx">
        {children}
      </DialogTrigger>
      <DialogContent className="flex flex-col gap-0 p-0 sm:max-h-[min(640px,80vh)] sm:max-w-lg" data-sentry-element="DialogContent" data-sentry-source-file="data-project-dialog.tsx">
        <DialogHeader className="contents space-y-0 text-left" data-sentry-element="DialogHeader" data-sentry-source-file="data-project-dialog.tsx">
          <DialogTitle className="border-b px-6 py-4 text-base" data-sentry-element="DialogTitle" data-sentry-source-file="data-project-dialog.tsx">
          {t('data-protect')}
          </DialogTitle>
          <div className="p-6 flex flex-col gap-4">
            <Button variant="outline" className="hover:bg-aloeGold hover:text-black" onClick={() => window.open("https://flptr.com/downloads/tr/dataprotect/tr/KVKKPolitikasi.pdf", "_blank")} data-sentry-element="Button" data-sentry-source-file="data-project-dialog.tsx">
              {t('text-kvkk-policy')}
            </Button>
            <Button variant="outline" className="hover:bg-aloeGold hover:text-black" onClick={() => window.open("https://flptr.com/downloads/tr/dataprotect/tr/CerezAydinlatmaMetni.pdf", "_blank")} data-sentry-element="Button" data-sentry-source-file="data-project-dialog.tsx">
              {t('text-cookie-policy')}
            </Button>
            <Button variant="outline" className="hover:bg-aloeGold hover:text-black" onClick={() => window.open("https://flptr.com/downloads/tr/dataprotect/tr/internetAydinlatmaMetni.pdf", "_blank")} data-sentry-element="Button" data-sentry-source-file="data-project-dialog.tsx">
              {t('text-internet-information')}
            </Button>
            <Button variant="outline" className="hover:bg-aloeGold hover:text-black" onClick={() => window.open("https://flptr.com/downloads/tr/dataprotect/tr/FBOAydinlatmaMetni.pdf", "_blank")} data-sentry-element="Button" data-sentry-source-file="data-project-dialog.tsx">
              {t('text-fbo-information')}
            </Button>
          </div>
        </DialogHeader>
      </DialogContent>
    </Dialog>;
};
export default DataProjectDialog;